// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container[data-v-154f4d64]{color:#141414;margin:8px}.contact-icon[data-v-154f4d64]{-o-object-fit:contain;object-fit:contain;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
